import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-phone-down",
  "use": "icon-s-phone-down-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-phone-down\"><path d=\"M21.253 9.94C15.593 4.28 6.415 4.27.747 9.94a.75.75 0 0 0-.106.927l1.768 2.829a.755.755 0 0 0 .915.3l3.535-1.414a.75.75 0 0 0 .466-.771l-.243-2.435c2.49-.9 5.29-.92 7.831 0l-.243 2.435a.75.75 0 0 0 .466.77l3.536 1.415c.34.133.727.007.92-.3l1.767-2.829a.75.75 0 0 0-.106-.928\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol